/* eslint-disable no-unused-vars */
import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';
enum ActionType {
  ISSUE_DETAIL_GET = 'ISSUE_DETAIL_GET',
  ISSUE_LIST_ALARM_BY_ISSUE_NO = 'ISSUE_LIST_ALARM_BY_ISSUE_NO',
  ISSUE_UPDATE = 'ISSUE_UPDATE',
  ISSUE_ADD = 'ISSUE_ADD',
  ISSUE_AVAILIBLE = 'ISSUE_AVAILIBLE',
  ISSUE_INIT_STATE = 'ISSUE_INIT_STATE',
  WORK_ORDER_INFO = 'DRAWER_INFO',
  CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION',
}

export const actionFetchIssueDetail = createAction<any>(
  eventProvider.makeResponseType(ActionType.ISSUE_DETAIL_GET),
);
export const actionFetchAlarmDetail = createAction<any>(
  eventProvider.makeResponseType(ActionType.ISSUE_LIST_ALARM_BY_ISSUE_NO),
);

export const actionIssueUpdate = createAction<any>(
  eventProvider.makeResponseType(ActionType.ISSUE_UPDATE),
);

export const actionIssueAdd = createAction<any>(
  eventProvider.makeResponseType(ActionType.ISSUE_ADD),
);
export const actionIssueAvailible = createAction<any>(
  eventProvider.makeResponseType(ActionType.ISSUE_AVAILIBLE),
);
export const actionInitTimestampFlag = createAction<any>(
  eventProvider.makeResponseType(ActionType.ISSUE_INIT_STATE),
);
export const actionCloseNotifation = createAction<any>(
  ActionType.CLOSE_NOTIFICATION,
);
export const actionWorkOrderInfo = createAction<any | undefined>(
  ActionType.WORK_ORDER_INFO,
);

export default ActionType;
